// src/helpers/notifications/templates/messages.ts

import { TemplateMeta } from '../notificationConfig';

export const messagesTemplates: TemplateMeta[] = [
    {
        key: 'message.received',
        label: 'Message Received',
        type: 'messages',
        icon: 'ri-mail-line text-primary',
        title: d => `New message from ${d.sender_name}`,
        subtitle: d => `In ${d.conversation_name}`,
    },
    // {
    //     key: 'comment.mentioned',
    //     label: 'Mention in Comment',
    //     type: 'messages',
    //     icon: 'ri-at-line text-warning',
    //     title: d => `${d.mentioner} mentioned you`,
    //     subtitle: d => `On ${d.record_name}`,
    // },
    {
        key: 'comment.added',
        label: 'Comment added',
        type: 'messages',
        icon: 'ri-file-edit-line text-warning',
        title: d => `${d.created_by} added comment ${d.type}`,
        subtitle: d => `On ${d.student_name}`,
    },
    // {
    //     key: 'group.announcement',
    //     label: 'Group Announcement',
    //     type: 'messages',
    //     icon: 'ri-group-line text-secondary',
    //     title: d => `New announcement in ${d.group_name}`,
    //     subtitle: d => `By ${d.announcer}`,
    // },
];
